import { render, staticRenderFns } from "./ModalFinance.vue?vue&type=template&id=2c752706&"
import script from "./ModalFinance.vue?vue&type=script&lang=js&"
export * from "./ModalFinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports